import React,{useState,useEffect} from 'react';
import Pagination from "react-js-pagination";
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,

  Tr,
  Th,
  Td,

  TableContainer,


  Input
} from '@chakra-ui/react'

import { fetchWrapper } from '../helpers';
import moment from 'moment';
import Header from '../components/Header'
import PageLoader from '../components/Loader/PageLoader';


function GetStarted() {
  const [list , setList]= useState([])

  const [listCount, setListCount] = useState(0); 

  const [date , setDate]= useState('')



  const [loading,setLoading] = useState(false);

  const [activePage, setActivePage] = useState(1);
 

  useEffect(()=>{
      
    loadlist(date);

    

  },[date])

  const loadlist = async(date="")=>{
    setLoading(true)

    const url = `${process.env.REACT_APP_API_URL}/get-touch/list?date=${date}`;

   

    const data  = await fetchWrapper.get(url)
    setList(data.rows);
    setListCount(data.count)
    setLoading(false)
  }

 

  const onChangePaginate = (pageNumber) => {
      setActivePage(pageNumber);
      // to set offset
      
  };

  return(
    <>
    <Header/>
    <PageLoader isLoading={loading} />
      <div className="body_section">
       
        
        <HStack justifyContent="space-between" mb="25px">
          <Box>
            <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">Getting Started</Text>
          </Box>
          <Box>
          	<Input type="date" onChange={(e) => setDate(e.target.value)}/>
          </Box>
        </HStack>
                           

        <div className="table_section">
          <TableContainer width="100%">
            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
              <Thead >
                <Tr>
                  <Th>Name</Th>
                  <Th>Email</Th>
                  <Th>Phone Number</Th>
                  <Th>Potential Monthly Messaging Traffic</Th>
                  <Th>Date & Time</Th>
                  <Th></Th>



                  

                  
                </Tr>
              </Thead>

              <Tbody fontSize="14px">
                  {list.map((rs,index)=>{
                    return(
                      <>
                          <Tr> 
                            <Td>{rs.full_name}</Td>
                            <Td>{rs.email}</Td>
                            <Td>{rs.contact_no}</Td>
                            
                            <Td>{rs.monthly_message_traffic}</Td>
                          

                            <Td>
                              <Text>{moment(rs.created_at).format('DD/MM/YY | HH:mm')}</Text>
                            </Td>
                          </Tr>
                      </>
                    )
                  })}

               
                            
                      
            
              </Tbody>
             
              
            </Table>
            <Pagination
               activePage={activePage}
               itemsCountPerPage={100}
               totalItemsCount={listCount}
               pageRangeDisplayed={100}
               onChange={onChangePaginate}
               innerClass="pagination"
               itemClass="page-item"
               activeLinkClass="page-link active"
               linkClass="page-link"
               prevPageText="Previous"
               nextPageText="Next"
              />
            
          </TableContainer>
        </div>
      </div>
    </>
  )
}

export default GetStarted;